// Single source of truth for which document types uploads accept across the
// app (waiver requests, waiver document attach, loan Documents tab). Used
// both as the <input accept="..."> value (which only filters the native
// file-picker dialog) and for real JS-side validation, since drag-and-drop
// bypasses the accept attribute entirely.
export const SUPPORTED_DOCUMENT_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".xlsx",
  ".csv",
  ".jpg",
  ".jpeg",
  ".png",
  ".xls"
];

export const SUPPORTED_DOCUMENT_ACCEPT = SUPPORTED_DOCUMENT_EXTENSIONS.join(",");

const getFileExtension = (fileName: string): string => {
  const lastDot = fileName?.lastIndexOf(".") ?? -1;
  return lastDot === -1 ? "" : fileName.slice(lastDot).toLowerCase();
};

export const isSupportedFileType = (file: { name: string }): boolean =>
  SUPPORTED_DOCUMENT_EXTENSIONS.includes(getFileExtension(file?.name ?? ""));

// Splits a batch of files (from either a file-picker selection or a
// drag-and-drop) into those that pass the extension allowlist and those that
// don't, so callers can stage/upload the former and surface an error for the
// latter rather than silently accepting anything.
export const partitionBySupportedFileType = <T extends { name: string }>(
  files: T[],
): { supported: T[]; unsupported: T[] } => {
  const supported: T[] = [];
  const unsupported: T[] = [];
  files.forEach((file) => (isSupportedFileType(file) ? supported : unsupported).push(file));
  return { supported, unsupported };
};
